import { render, staticRenderFns } from "./Franchise.vue?vue&type=template&id=5af62eb9"
import script from "./Franchise.vue?vue&type=script&lang=js"
export * from "./Franchise.vue?vue&type=script&lang=js"
import style0 from "./Franchise.vue?vue&type=style&index=0&id=5af62eb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports